import React from "react";

class Banner extends React.Component {
  render() {
    const firstItemPath = {
      background: "url(/images/110618-005.jpg)"
    };
    const vertical = {
      paddingLeft: "10%"
    };

    const paddingStyle = {
      paddingLeft: "10%",
      textAlign: "right",
      paddingRight: "10%"
    };

    const paddingLeftStyle = {
      paddingLeft: "10%"
    };
    return (
      <section className="header_section header_section_promo">
        {/* <div className="bg-overlay" / >*/}
        <div className="container">
          <div className="row">

            <div className="col-lg-10 text-w">
              <div className="desktop-header">
                <h1 className="sub no-margin bold600 mb-3 text-w">The best choice<br/>to stay connected anywhere</h1>
                <div className="col-md-12" style={{ clear: "both", height: "20px" }} />
                <div className="row">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-3">
                      <div className="icon-box">
                        <div className="icon global"></div>
                      </div>
                      </div>
                      <div className="col-md-9 text-shadow font15 icon-text-box">
                        <span className="icon-text">
                        <strong>Global Coverage</strong><br/>One-Touch Access to personal wifi in over 150+ Countries - No Sim cards needed.
                        </span>
                      </div>

                      <div className="col-md-12" style={{ clear: "both", height: "20px" }} />

                      <div className="col-md-3">
                      <div className="icon-box">
                        <div className="icon hub"></div>
                      </div>
                      </div>
                      <div className="col-md-9 text-shadow font15 icon-text-box">
                        <span className="icon-text">
                        <strong>Portable Global Smart Hub</strong><br/>Keep your phone, laptop, and IOT devices online everywhere at one low rate.
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-3">
                      <div className="icon-box">
                        <div className="icon share"></div>
                      </div>
                      </div>
                      <div className="col-md-9 text-shadow font15 icon-text-box">
                        <span className="icon-text">
                        <strong>Shareable</strong><br/>Connect up to 10 devices at once. Keep your travel buddies online too!
                        </span>
                      </div>

                      <div className="col-md-12" style={{ clear: "both", height: "20px" }} />

                      <div className="col-md-3">
                      <div className="icon-box">
                        <div className="icon battery"></div>
                      </div>
                      </div>
                      <div className="col-md-9 text-shadow font15 icon-text-box">
                        <span className="icon-text">
                        <strong>Long Lasting</strong><br/>Stay powered-on all day long with 11-13 hours of WiFi battery life
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-2"></div>

              </div>
            </div>

            {/*
            <div className="mobile-header">
              <h2 className="SansSerif bold600 m-title-positon">
                <span className="line-break m-header-mtitle Serif">Coming Soon</span>
                <span className="line-break m-header-stitle">2ND generation of global wifi hotspot</span>
                MightyWifi Cloud
              </h2>
            </div>
            */}

          </div>
        </div>
        <div id="BuySection"></div>
      </section>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/pages/sale/Banner.js